function App() {
  return (
    <div>
      <h1>My App React</h1>
    </div>
  );
}

export default App;
